import { cn } from '@bw/core';
import { Image } from '@bw/elements';
import { Block } from '../../factories/types';
import { schemeToClass } from '../../utils/colorMap';
import styles from './ImageMarquee.module.scss';

export const ImageMarquee: Block<'imageMarque'> = ({
	data: {
		fields: { title, images, colorScheme = 'Default (white)' },
	},
	fieldId,
}) => {
	return (
		<section
			className={cn(
				styles.imageMarqueeContainer,
				schemeToClass(colorScheme)
			)}
		>
			<div className="container container--max">
				{title && <h2 {...fieldId('title')}>{title}</h2>}

				<div className={styles.imageMarquee} {...fieldId('images')}>
					<div className={styles.track}>
						{images?.map(
							(image, index) =>
								image?.fields.file?.url && (
									<div className={styles.logo} key={index}>
										<Image
											src={image?.fields.file?.url}
											alt={image.fields.file.fileName}
											width={100}
											height={100}
											loading="eager"
										/>
									</div>
								)
						)}
					</div>

					<div className={styles.track} aria-hidden="true">
						{images?.map(
							(image, index) =>
								image?.fields.file?.url && (
									<div className={styles.logo} key={index}>
										<figure>
											<Image
												src={image.fields.file.url}
												alt={image.fields.file.fileName}
												width={100}
												height={100}
												loading="eager"
											/>
										</figure>
									</div>
								)
						)}
					</div>
				</div>
			</div>
		</section>
	);
};
